import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.724 7.564v3.241h5.403v12.968h3.242V10.805h5.403V7.564H5.724zm20.532 5.403H16.53v3.241h3.242v7.565h3.242v-7.565h3.242v-3.241z" fill="#54585D" /></svg>);